import BlogArticleLayout from '@/components/feature/BlogArticleLayout';

export default function SegurancaComprasPage() {
  return <BlogArticleLayout slug="seguranca-compras-hoobuy" />;
}